import { createSlice } from "@reduxjs/toolkit";
import { initialSignatureState } from "./signature.types";
import { LoadState } from "../../constants/enums";
import { fetchAllSignatures, fetchSignaturesList } from "./signatureThunk";

const signatureSlice = createSlice({
  name: "signature",
  initialState: initialSignatureState,
  reducers: {
    clearSignatureState: (state) => {
      state.list = [];
      state.loading = LoadState.NotLoaded;
    },
    clearAllSignatures: (state) => {
      state.allSignatures = [];
      state.allSignaturesLoading = LoadState.NotLoaded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSignaturesList.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.list = [];
    });
    builder.addCase(fetchSignaturesList.fulfilled, (state, action) => {
      state.list = action.payload.data;
      state.loading = LoadState.Loaded;
    });
    builder.addCase(fetchSignaturesList.rejected, (state) => {
      state.loading = LoadState.Failed;
      state.list = [];
    });
    builder.addCase(fetchAllSignatures.pending, (state) => {
      state.allSignaturesLoading = LoadState.InProgress;
      state.allSignatures = [];
    });
    builder.addCase(fetchAllSignatures.fulfilled, (state, action) => {
      state.allSignatures = action.payload.data;
      state.allSignaturesLoading = LoadState.Loaded;
    });
    builder.addCase(fetchAllSignatures.rejected, (state) => {
      state.allSignaturesLoading = LoadState.Failed;
      state.allSignatures = [];
    });
  },
});

export const { clearSignatureState, clearAllSignatures } = signatureSlice.actions;

export const signatureReducer = signatureSlice.reducer;
